import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ToastService } from './toast.service';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 5000,
      preventDuplicates: true,
    }),
  ],
  declarations: [],
  exports: [],
})
export class ToastModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: ToastModule,
      providers: [ToastService],
    };
  }
}
